import { TokenDeliveryDto } from './../../Models/Auth/Auth';
import { Injectable } from '@angular/core';
import { HttpRequestService } from './http-request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private controllerUrl = `${environment.baseUrl}/Token`;

  constructor(private http: HttpRequestService) {}

  public async refreshToken(
    request: TokenDeliveryDto
  ): Promise<TokenDeliveryDto> {
    console.log(request);
    return new Promise<TokenDeliveryDto>(async (resolve, reject) => {
      let serviceResponse: TokenDeliveryDto = null;

      await this.http
        .request<TokenDeliveryDto>(
          `${this.controllerUrl}/RequestTokenRefresh`,
          request,
          'GET',
          true
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.error) {
              return reject(response.error);
            }

            serviceResponse = response.body;
          } else {
            return reject(response.error);
          }

          resolve(serviceResponse);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}
